"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Loops over each item of a sequence.
 *
 * <pre>
 * <ul>
 *  {% for user in users %}
 *    <li>{{ user.username|e }}</li>
 *  {% endfor %}
 * </ul>
 * </pre>
 */
const token_parser_1 = require("../token-parser");
const node_1 = require("../node");
const token_1 = require("../token");
const syntax_1 = require("../error/syntax");
const assign_name_1 = require("../node/expression/assign-name");
const for_1 = require("../node/for");
class TwingTokenParserFor extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let stream = this.parser.getStream();
        let targets = this.parser.getExpressionParser().parseAssignmentExpression();
        stream.expect(token_1.TwingToken.OPERATOR_TYPE, 'in');
        let seq = this.parser.getExpressionParser().parseExpression();
        let ifexpr = null;
        if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'if')) {
            console.error('Using an "if" condition on "for" tag is deprecated since Twig 2.10.0, use a "filter" filter or an "if" condition inside the "for" body instead (if your condition depends on a variable updated inside the loop).');
            ifexpr = this.parser.getExpressionParser().parseExpression();
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let body = this.parser.subparse([this, this.decideForFork]);
        let elseToken;
        if (stream.next().getValue() == 'else') {
            stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
            elseToken = this.parser.subparse([this, this.decideForEnd], true);
        }
        else {
            elseToken = null;
        }
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let keyTarget;
        let valueTarget;
        if ((targets.getNodes().size) > 1) {
            keyTarget = targets.getNode(0);
            keyTarget = new assign_name_1.TwingNodeExpressionAssignName(keyTarget.getAttribute('name'), keyTarget.getTemplateLine(), keyTarget.getTemplateColumn());
            valueTarget = targets.getNode(1);
            valueTarget = new assign_name_1.TwingNodeExpressionAssignName(valueTarget.getAttribute('name'), valueTarget.getTemplateLine(), valueTarget.getTemplateColumn());
        }
        else {
            keyTarget = new assign_name_1.TwingNodeExpressionAssignName('_key', lineno, columnno);
            valueTarget = targets.getNode(0);
            valueTarget = new assign_name_1.TwingNodeExpressionAssignName(valueTarget.getAttribute('name'), valueTarget.getTemplateLine(), valueTarget.getTemplateColumn());
        }
        if (ifexpr) {
            this.checkLoopUsageCondition(stream, ifexpr);
            this.checkLoopUsageBody(stream, body);
        }
        return new for_1.TwingNodeFor(keyTarget, valueTarget, seq, ifexpr, body, elseToken, lineno, columnno, this.getTag());
    }
    decideForFork(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, ['else', 'endfor']);
    }
    decideForEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endfor');
    }
    // the loop variable cannot be used in the condition
    checkLoopUsageCondition(stream, node) {
        let self = this;
        if ((node.getType() === node_1.TwingNodeType.EXPRESSION_GET_ATTR) && (node.getNode('node').getType() === node_1.TwingNodeType.EXPRESSION_NAME) && (node.getNode('node').getAttribute('name') === 'loop')) {
            throw new syntax_1.TwingErrorSyntax('The "loop" variable cannot be used in a looping condition.', node.getTemplateLine(), stream.getSourceContext());
        }
        node.getNodes().forEach(function (n) {
            self.checkLoopUsageCondition(stream, n);
        });
    }
    // check usage of non-defined loop-items
    getTag() {
        return 'for';
    }
    // it does not catch all problems (for instance when a for is included into another or when the variable is used in an include)
    checkLoopUsageBody(stream, node) {
        if ((node.getType() === node_1.TwingNodeType.EXPRESSION_GET_ATTR) && (node.getNode('node').getType() === node_1.TwingNodeType.EXPRESSION_NAME) && (node.getNode('node').getAttribute('name') === 'loop')) {
            let attribute = node.getNode('attribute');
            if ((attribute.getType() === node_1.TwingNodeType.EXPRESSION_CONSTANT) && (['length', 'revindex0', 'revindex', 'last'].indexOf(attribute.getAttribute('value')) > -1)) {
                throw new syntax_1.TwingErrorSyntax(`The "loop.${attribute.getAttribute('value')}" variable is not defined when looping with a condition.`, node.getTemplateLine(), stream.getSourceContext());
            }
        }
        // should check for parent.loop.XXX usage
        if (node.getType() === node_1.TwingNodeType.FOR) {
            return;
        }
        for (let [k, n] of node.getNodes()) {
            this.checkLoopUsageBody(stream, n);
        }
    }
}
exports.TwingTokenParserFor = TwingTokenParserFor;
